import { avatarGroupConfig, component, mergeConfig } from '@salutejs/plasma-new-hope/css';

const mergedConfig = mergeConfig(avatarGroupConfig);

export const AvatarGroup = component(mergedConfig);
